var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.576 20.515H2.424c-.918 0-1.662-.652-1.662-1.455V1.692C.762.89 1.506.24 2.424.24h19.152c.917 0 1.66.651 1.66 1.453V19.06c0 .803-.743 1.455-1.66 1.455zm-16.919-3.34h3.31V8.02h-3.31v9.154zM6.334 3.607c-1.133 0-1.872.683-1.872 1.582 0 .877.718 1.582 1.828 1.582h.022c1.154 0 1.872-.705 1.872-1.582-.02-.899-.718-1.582-1.85-1.582zm13.567 8.318c0-2.812-1.634-4.12-3.81-4.12-1.758 0-2.543.887-2.983 1.512V8.02h-3.31c.044.86 0 9.154 0 9.154h3.31v-5.111c0-.273.021-.547.11-.742.238-.547.783-1.112 1.697-1.112 1.198 0 1.676.839 1.676 2.07v4.895h3.31v-5.248zm-6.816-2.578l.023-.03v.03h-.023z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "img/_/_/views/utils/components/Footer/assets/svg/linkedin-white.svg";
export { SvgLinkedinWhite as ReactComponent };